import Vue from 'vue'
import App from './App.vue'
import router from './router'
import reveal from './directives/reveal'
import './assets/css/global.scss'

Vue.config.productionTip = false
Vue.directive('reveal', reveal)

/* 站点基础信息（供 SEO / 全局使用） */
Vue.prototype.$site = {
  name: '海阳皓辰网络科技有限公司',
  brand: '皓辰科技',
  slogan: '让产业现场长出智能'
}

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
